<div class="app-shell" [class.nav-open]="navOpen()">
  <button
    type="button"
    class="nav-scrim"
    aria-label="Close navigation"
    tabindex="-1"
    (click)="closeNav()"
  ></button>

  <aside class="sidebar">
    <a routerLink="/dashboard" class="side-brand">
      <img class="mark" src="/deoria-government-logo.jpg" alt="Government of Uttar Pradesh" />
      <div>
        <strong>Jansunwai</strong>
        <small>Deoria District Portal</small>
      </div>
    </a>

    @if (useWorkspaceNav()) {
      <nav class="dm-nav" aria-label="Main navigation">
        <p class="dm-nav-label">Workspace</p>
        <a routerLink="/dashboard" [class.active]="crumb() === 'Dashboard'">
          <span class="dm-nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
          </span>
          <span><strong>Dashboard</strong><small>District overview</small></span>
          <span class="dm-nav-arrow" aria-hidden="true">›</span>
        </a>
        <a
          routerLink="/complaints"
          [class.active]="crumb() === 'Complaint Management' || crumb() === 'Complaint Detail'"
        >
          <span class="dm-nav-icon complaints" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg>
          </span>
          <span><strong>Complaints</strong><small>Review and manage cases</small></span>
          <span class="dm-nav-arrow" aria-hidden="true">›</span>
        </a>
        <a routerLink="/complaints/search" [class.active]="crumb() === 'Search all cases'">
          <span class="dm-nav-icon search" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
          </span>
          <span><strong>Search all cases</strong><small>Find anything, any case</small></span>
          <span class="dm-nav-arrow" aria-hidden="true">›</span>
        </a>
        <a routerLink="/assistant" [class.active]="crumb() === 'Ask AI'">
          <span class="dm-nav-icon ask" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3 1.8 4.4L18 9l-4.2 1.6L12 15l-1.8-4.4L6 9l4.2-1.6L12 3Z"/><path d="M19 15.5 19.6 17 21 17.6 19.6 18.2 19 19.7 18.4 18.2 17 17.6 18.4 17 19 15.5Z"/></svg>
          </span>
          <span><strong>Ask AI</strong><small>Ask about any case</small></span>
          <span class="dm-nav-arrow" aria-hidden="true">›</span>
        </a>
        @if (isAdmin()) {
          <a
            routerLink="/document-ocr"
            [class.active]="crumb().startsWith('Document OCR')"
          >
            <span class="dm-nav-icon docs" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M8 13h8M8 17h6"/></svg>
            </span>
            <span><strong>Document OCR</strong><small>Records intake</small></span>
            <span class="dm-nav-arrow" aria-hidden="true">›</span>
          </a>
        }
        @if (adminNavItems().length) {
          <div
            class="nav-group dm-admin-group"
            [class.is-open]="isGroupOpen('administration')"
            [class.has-active]="groupHasActive({ items: adminNavItems() })"
          >
            <button
              type="button"
              class="side-group-btn"
              (click)="toggleGroup('administration')"
              [attr.aria-expanded]="isGroupOpen('administration')"
            >
              <span class="nav-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3 5 6v5c0 5 3.5 8.5 7 10 3.5-1.5 7-5 7-10V6l-7-3z"/></svg>
              </span>
              <span class="side-group-title">Administration</span>
              <span class="chevron" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m6 9 6 6 6-6"/></svg>
              </span>
            </button>
            @if (isGroupOpen('administration')) {
              <nav class="side-subnav" aria-label="Administration">
                @for (item of adminNavItems(); track item.path) {
                  <a [routerLink]="item.path" [class.active]="isNavItemActive(item)">
                    <span class="nav-icon sm" aria-hidden="true">
                      @switch (item.icon) {
                        @case ('gear') {
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
                        }
                        @case ('shield') {
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3 5 6v5c0 5 3.5 8.5 7 10 3.5-1.5 7-5 7-10V6l-7-3z"/></svg>
                        }
                        @case ('docs') {
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
                        }
                      }
                    </span>
                    {{ item.label }}
                  </a>
                }
              </nav>
            }
          </div>
        }
        <a routerLink="/notifications" [class.active]="crumb() === 'Notifications'">
          <span class="dm-nav-icon notifications" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10 21a2 2 0 0 0 4 0"/></svg>
          </span>
          <span><strong>Notifications</strong><small>Updates and alerts</small></span>
          @if (unread() > 0) {
            <em class="dm-nav-badge">{{ unread() }}</em>
          } @else {
            <span class="dm-nav-arrow" aria-hidden="true">›</span>
          }
        </a>
      </nav>
    } @else {
      @for (group of navGroups(); track group.id) {
        <div class="nav-group" [class.is-open]="isGroupOpen(group.id)" [class.has-active]="groupHasActive(group)">
        <button
          type="button"
          class="side-group-btn"
          (click)="toggleGroup(group.id)"
          [attr.aria-expanded]="isGroupOpen(group.id)"
        >
          <span class="nav-icon" aria-hidden="true">
            @switch (group.icon) {
              @case ('overview') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
              }
              @case ('folder') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z"/></svg>
              }
              @case ('gavel') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m14 4 6 6M4 20l7-7M13 5l6 6M9 15l-5 5M8 8l8 8"/></svg>
              }
              @case ('docs') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M8 13h8M8 17h6"/></svg>
              }
              @case ('account') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 20a8 8 0 0 1 16 0"/></svg>
              }
              @case ('shield') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3 5 6v5c0 5 3.5 8.5 7 10 3.5-1.5 7-5 7-10V6l-7-3z"/></svg>
              }
            }
          </span>
          <span class="side-group-title">{{ group.title }}</span>
          <span class="chevron" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m6 9 6 6 6-6"/></svg>
          </span>
        </button>

        @if (isGroupOpen(group.id)) {
          <nav class="side-subnav">
            @for (item of group.items; track item.label) {
              <a
                [routerLink]="item.path"
                [class.active]="isNavItemActive(item)"
              >
                <span class="nav-icon sm" aria-hidden="true">
                  @switch (item.icon) {
                    @case ('home') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 11.5 12 4l9 7.5"/><path d="M6 10.5V20h12v-9.5"/></svg>
                    }
                    @case ('bell') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10 21a2 2 0 0 0 4 0"/></svg>
                    }
                    @case ('list') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg>
                    }
                    @case ('check') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
                    }
                    @case ('flow') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="6" cy="6" r="2.5"/><circle cx="18" cy="12" r="2.5"/><circle cx="6" cy="18" r="2.5"/><path d="M8.5 7.5 15.5 11M8.5 16.5 15.5 13"/></svg>
                    }
                    @case ('briefcase') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18"/></svg>
                    }
                    @case ('calendar') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 11h18"/></svg>
                    }
                    @case ('gavel') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m14 4 6 6M4 20l7-7M13 5l6 6M9 15l-5 5M8 8l8 8"/></svg>
                    }
                    @case ('users') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="8" r="3.5"/><path d="M2.5 19a6.5 6.5 0 0 1 13 0"/><circle cx="17" cy="9" r="2.5"/><path d="M15.5 19a4.5 4.5 0 0 1 6 0"/></svg>
                    }
                    @case ('stamp') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 14h8v3H8z"/><path d="M10 14V9a2 2 0 0 1 4 0v5"/><path d="M5 20h14"/></svg>
                    }
                    @case ('scan') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 8V5a1 1 0 0 1 1-1h3M20 8V5a1 1 0 0 0-1-1h-3M4 16v3a1 1 0 0 0 1 1h3M20 16v3a1 1 0 0 1-1 1h-3"/><path d="M7 12h10"/></svg>
                    }
                    @case ('chart') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19V5M4 19h16"/><path d="M8 16V10M12 16V7M16 16v-4"/></svg>
                    }
                    @case ('shield') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3 5 6v5c0 5 3.5 8.5 7 10 3.5-1.5 7-5 7-10V6l-7-3z"/></svg>
                    }
                    @case ('gear') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
                    }
                    @case ('user') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 20a8 8 0 0 1 16 0"/></svg>
                    }
                    @case ('search') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
                    }
                    @case ('sparkle') {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3 1.8 4.4L18 9l-4.2 1.6L12 15l-1.8-4.4L6 9l4.2-1.6L12 3Z"/><path d="M19 15.5 19.6 17 21 17.6 19.6 18.2 19 19.7 18.4 18.2 17 17.6 18.4 17 19 15.5Z"/></svg>
                    }
                  }
                </span>
                {{ item.label }}
              </a>
            }
          </nav>
        }
        </div>
      }
    }
  </aside>

  <div class="main-col">
    <header class="topnav">
      <button
        type="button"
        class="nav-toggle"
        (click)="toggleNav()"
        [attr.aria-expanded]="navOpen()"
        aria-label="Toggle navigation menu"
      >
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          @if (navOpen()) {
            <path d="M6 6l12 12M18 6L6 18" />
          } @else {
            <path d="M4 7h16M4 12h16M4 17h16" />
          }
        </svg>
      </button>

      <div class="crumb">
        <span>District Administration</span>
        <span class="sep">›</span>
        <span>Jansunwai</span>
        <span class="sep">/</span>
        <strong>{{ crumb() }}</strong>
      </div>

      <div class="top-actions">
        @if (canNotifications()) {
          <div class="menu-wrap">
            <button type="button" class="icon-round" (click)="toggleNotifs()" aria-label="Notifications">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                <path d="M10 21a2 2 0 0 0 4 0" />
              </svg>
              @if (unread() > 0) {
                <em>{{ unread() }}</em>
              }
            </button>
            @if (showNotifs()) {
              <div class="dropdown">
                <p class="drop-title">Notifications</p>
                @for (n of recentNotifs(); track n.id) {
                  <button type="button" class="drop-item" (click)="openNotificationsPage()">
                    <strong>{{ n.title }}</strong>
                    <span>{{ n.body }}</span>
                  </button>
                }
                <button type="button" class="drop-link" (click)="openNotificationsPage()">View all</button>
              </div>
            }
          </div>
        }

        <button
          type="button"
          class="icon-round"
          (click)="toggleTheme()"
          [attr.aria-label]="theme() === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'"
          [attr.title]="theme() === 'dark' ? 'Light mode' : 'Dark mode'"
        >
          @if (theme() === 'dark') {
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <circle cx="12" cy="12" r="4" />
              <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
            </svg>
          } @else {
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M21 14.5A8.5 8.5 0 1 1 9.5 3 7 7 0 0 0 21 14.5z" />
            </svg>
          }
        </button>

        <button type="button" class="lang-chip" aria-label="Language">EN</button>

        <div class="menu-wrap">
          <div class="profile-cluster">
            <a
              routerLink="/profile"
              class="avatar-link"
              [attr.title]="'Open profile'"
              aria-label="Open profile"
              (click)="showProfileMenu.set(false)"
            >
              <span class="avatar">{{ initials() }}</span>
            </a>
            <button type="button" class="profile-btn" (click)="toggleProfile()">
              <span class="who">
                <strong>{{ officer()?.name }}</strong>
                <small>{{ roleLabel() }}</small>
              </span>
            </button>
          </div>
          @if (showProfileMenu()) {
            <div class="dropdown right">
              @if (canSettings()) {
                <a routerLink="/settings" class="drop-item" (click)="showProfileMenu.set(false)">
                  <strong>User management</strong>
                  <span>Users &amp; contacts</span>
                </a>
              }
              <button type="button" class="drop-link danger" (click)="logout()">Logout</button>
            </div>
          }
        </div>
      </div>
    </header>

    <main class="content">
      <router-outlet />
    </main>
  </div>

  <app-chat-widget />
</div>
